export enum EvictionStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  ARCHIVED = 'ARCHIVED',
  INTAKE_EVICTION = 'INTAKE_EVICTION'
}
